interface IntentConfig {
  intent: "error" | "warning" | undefined;
  intentContent: string | undefined;
  intentIcon: "triangle-exclamation" | "info" | undefined;
}

interface GetBottomSheetIntentParams {
  saveAttempted: boolean;
  errorMessage?: string;
  warningMessage?: string;
}

/**
 * Determines the intent configuration for BottomSheetWithIntent based on validation state.
 * Prioritizes errors over warnings.
 */
export function getBottomSheetIntent(params: GetBottomSheetIntentParams): IntentConfig {
  const { saveAttempted, errorMessage, warningMessage } = params;

  const shouldShowError = saveAttempted && errorMessage;
  const shouldShowWarning = !shouldShowError && warningMessage;

  if (shouldShowError) {
    return {
      intent: "error",
      intentContent: errorMessage,
      intentIcon: "triangle-exclamation",
    };
  }

  if (shouldShowWarning) {
    return {
      intent: "warning",
      intentContent: warningMessage,
      intentIcon: "info",
    };
  }

  return {
    intent: undefined,
    intentContent: undefined,
    intentIcon: undefined,
  };
}
